// JOBE-0106: OverviewBody — two-column grid per the wireframe.
// Left:  Decide today (mock) + Tasks (compact list)
// Right: Entities by kind (kbox tiles) + Recent documents (compact list)

import React from 'react';
import { DecideTodayLane } from './DecideTodayLane.jsx';
import { EntitiesByKindGrid } from './EntitiesByKindGrid.jsx';
import { CompactEntityList } from './CompactEntityList.jsx';

export function OverviewBody({ projectURN, counts }) {
  return (
    <div className="project-overview-body" data-testid="project-overview-body">
      <div className="project-overview-column project-overview-left">
        <DecideTodayLane />
        <CompactEntityList
          projectURN={projectURN}
          namespace="tasks"
          defaultType="task"
          title="Tasks in this project"
          emptyLabel="No tasks in this project yet."
        />
      </div>
      <div className="project-overview-column project-overview-right">
        <EntitiesByKindGrid
          projectURN={projectURN}
          entitiesByKind={counts?.entities_by_kind || {}}
        />
        <CompactEntityList
          projectURN={projectURN}
          namespace="documents"
          defaultType="document"
          title="Recent documents"
          emptyLabel="No documents in this project yet."
        />
      </div>
    </div>
  );
}
